import { mergeAlways } from './utils';

export const bootCommon = ({ prev, patchEndereco, empresaVaiEm, empresaArmazenada, parametro, operacaoParametros }) => {
    const patchEnderecoData = patchEndereco ? patchEndereco(empresaVaiEm, empresaArmazenada, parametro) : {};

    const patch = {
        ...patchEnderecoData,

        // 👉 NOVO PARAMETRO
        almoxarifadoId: operacaoParametros?.almoxarifadoId ?? prev?.almoxarifadoId ?? null,
        situacaoId: operacaoParametros?.situacaoId ?? prev?.situacaoId ?? null,
        operacaoId: operacaoParametros?.operacaoId ?? prev?.operacaoId ?? null,
        contaId: operacaoParametros?.lancamentoContaId ?? prev?.contaId ?? null,
    };

    return mergeAlways(prev, patch);
};
